import React from 'react';

import NProgress from 'nprogress';
import { notify } from 'utils';
import { getVtt, vttToUrl, getSubFromVttUrl } from 'utils/subtitle';

import { Upload } from './styles';

export default function({ player, options, setOption, updateSubtitles }) {
  async function openSubtitle(file) {
    if (file) {
      NProgress.start().set(0.5);
      try {
        const vttText = await getVtt(file);
        if (vttText) {
          const subtitleUrl = vttToUrl(vttText);
          updateSubtitles(await getSubFromVttUrl(subtitleUrl));
          player.subtitle.switch(subtitleUrl);
          setOption({ subtitleUrl, uploadDialog: false });
          notify('Legendas carregadas');
        } else {
          notify('Erro ao abrir as legendas', 'error');
        }
      } catch (error) {
        notify(error.message, 'error');
      }
      NProgress.done();
    }
  }

  async function openVideo(file) {
    if (file) {
      NProgress.start().set(0.5);
      if (typeof file === 'string') {
        player.url = file;
        setOption({ videoUrl: file, uploadDialog: false });
        notify('Video carregado com sucesso');
      } else {
        const $video = document.createElement('video');
        const canPlayType = $video.canPlayType(file.type);
        if (canPlayType === 'maybe' || canPlayType === 'probably') {
          const videoUrl = URL.createObjectURL(file);
          player.url = videoUrl;
          /*  let blob = await fetch(
                        'http://rpc-adx.ddns.net:3003/preview/video/07-44-9F-97-63-55-8B-3A-42-2B-EB-DA-1E-E0-35-FD?signed=r:5714496041;e:1592633815;m:GET;6abb5b53f81cce45849a6e255e42193b',
                    ).then((r) => r.blob());

                    var videoUrl = window.URL
                        ? window.URL.createObjectURL(blob)
                        : window.webkitURL.createObjectURL(blob); */
          setOption({ videoUrl: videoUrl, uploadDialog: false });
          player.url = videoUrl;
          notify('Video carregado com sucesso');
        } else {
          notify('Erro ao carregar o video', 'error');
        }
      }
      NProgress.done();
    }
  }

  return (
    <Upload>
      <div className="item">
        <div className="title">
          <p>Selecionar legenda</p>
        </div>
        <div className="centent">
          <div className="upload">
            <input
              disabled
              value={options.subtitleUrl}
              type="text"
              className="input"
              spellCheck="false"
              onChange={event => openSubtitle(event.target.value)}
            />
            <div className="file">
              <p>Selecionar</p>
              <input
                type="file"
                onChange={event => openSubtitle(event.target.files[0])}
              />
            </div>
          </div>
          <div className="info">
            <p>Apenas legendas em formato .vtt, .srt e .ass são suportados</p>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="title">
          <p>Selecionar vídeo</p>
        </div>
        <div className="centent">
          <div className="upload">
            <input
              disabled
              value={options.videoUrl}
              type="text"
              className="input"
              spellCheck="false"
              onChange={event => openVideo(event.target.value)}
            />
            <div className="file">
              <p>Selecionar</p>
              <input
                type="file"
                onChange={event => openVideo(event.target.files[0])}
              />
            </div>
          </div>
          <div className="info">
            <p>Apenas arquivos em formato .mp4, .webm e .ogg são portados</p>
          </div>
          <div className="warning">
            <p>
              Os arquivos são abertos localmente e nenhum dado é carregado. Ao
              criar uma forma de onda de áudio, o navegador pode ficar bloqueado
              por um curto período de tempo devido à decodificação de áudio
            </p>
          </div>
        </div>
      </div>
    </Upload>
  );
}
